import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-58f59168"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "iphone_img"
};
const _hoisted_2 = {
  class: "iphone_img_content"
};

const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "title"
}, "APP收集个人信息清单", -1));

const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "preface"
}, " 在使用APP上服务时，我们可能会收集您在具体业务场景中主动提供的，或通过自动化手段收集您在使用服务中产生的下述信息： ", -1));

const _hoisted_5 = {
  class: "preview-table"
};

const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [/*#__PURE__*/_createElementVNode("tr", null, [/*#__PURE__*/_createElementVNode("th", null, "信息种类"), /*#__PURE__*/_createElementVNode("th", null, "信息项"), /*#__PURE__*/_createElementVNode("th", null, "使用目的"), /*#__PURE__*/_createElementVNode("th", null, "使用场景")])], -1));

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _hoisted_4, _createElementVNode("div", _hoisted_5, [_createElementVNode("table", null, [_hoisted_6, _createElementVNode("tbody", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.list, (item, index) => {
    return _openBlock(), _createElementBlock("tr", {
      key: index
    }, [_createElementVNode("td", null, _toDisplayString(item.category), 1), _createElementVNode("td", null, _toDisplayString(item.item), 1), _createElementVNode("td", null, _toDisplayString(item.use_purpose), 1), _createElementVNode("td", null, _toDisplayString(item.use_scene), 1)]);
  }), 128))])])])])])]);
}